// Types under ./generated are produced from specs/**/contracts/openapi.yaml by `pnpm generate`.
// They are build output: never hand-edit them, and never let them drift (see `generate:check`).
export const CAPABILITIES = {
  USER_MANAGE: 'USER_MANAGE',
  ROLE_MANAGE: 'ROLE_MANAGE',
  SUPPLIER_MANAGE: 'SUPPLIER_MANAGE',
  TRANSFER_ORDER_MANAGE: 'TRANSFER_ORDER_MANAGE',
  SETTINGS_MANAGE: 'SETTINGS_MANAGE',
  RECORD_DELETE: 'RECORD_DELETE',
  SUPPLIER_MONTH_LINE_DELETE: 'SUPPLIER_MONTH_LINE_DELETE',
  SUPPLIER_INVOICE_DELETE: 'SUPPLIER_INVOICE_DELETE',
  DRIVE_MANAGE: 'DRIVE_MANAGE',
  SESSION_MANAGE: 'SESSION_MANAGE',
  AUDIT_READ: 'AUDIT_READ',
  REFERENCE_MANAGE: 'REFERENCE_MANAGE',
  IMPERSONATE: 'IMPERSONATE',
  SOURCE_MANAGE: 'SOURCE_MANAGE',
  TEAM_TIMESHEET_READ: 'TEAM_TIMESHEET_READ',
  TEAM_TIMESHEET_EDIT: 'TEAM_TIMESHEET_EDIT',
  ALL_TIMESHEET_EDIT: 'ALL_TIMESHEET_EDIT',
  TEAM_SCOPE_MANAGE: 'TEAM_SCOPE_MANAGE',
  FINANCE_MANAGE: 'FINANCE_MANAGE',
  CLIENT_BILLING_MANAGE: 'CLIENT_BILLING_MANAGE',
  FINANCIAL_EXPORT: 'FINANCIAL_EXPORT',
  SELF_READ: 'SELF_READ',
} as const;

export type Capability = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];

export const GLOBAL_ROLES = [
  'PERSONNEL',
  'TEAM_MANAGER',
  'OPERATIONS_MANAGER',
  'PURCHASING_MANAGER',
  'FINANCE_MANAGER',
  'ADMIN',
] as const;
export type GlobalRole = (typeof GLOBAL_ROLES)[number];
export function isGlobalRole(value: unknown): value is GlobalRole {
  return GLOBAL_ROLES.some((role) => role === value);
}
